module.exports = __webpack_public_path__ + "MaterialIcons-Regular.a37b0c01c0baf1888ca8.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/assets/MaterialIcons/iconfont/MaterialIcons-Regular.ttf
// module id = ../../../../../src/assets/MaterialIcons/iconfont/MaterialIcons-Regular.ttf
// module chunks = styles